export default "__VITE_ASSET__BouwQc19__"